import rest from '../utils/rest';

export default {
  drug: rest('/api/drugs/:id'),
  icd: rest('/api/icds/:id'),
  user: rest('/api/users/:id'),
};
